
import { BaseBackgroundEffect } from '../BaseBackgroundEffect';
import { BackgroundContext } from '../BackgroundEffect';

export class RadialGradientBackground extends BaseBackgroundEffect {
    public render(bc: BackgroundContext): void {
        const { ctx, width, height } = bc;
        const centerX = width / 2;
        const centerY = height / 2;
        const maxRadius = Math.sqrt(centerX * centerX + centerY * centerY);
        
        const grad = ctx.createRadialGradient(centerX, centerY, 0, centerX, centerY, maxRadius);
        grad.addColorStop(0, this.getPrimaryColor(bc));
        grad.addColorStop(1, this.getSecondaryColor(bc));
        
        ctx.fillStyle = grad;
        ctx.fillRect(0, 0, width, height);
    }
}
